import React from 'react'
import { Form } from '@s4l/ds'
import { IconTrash } from '@s4l/icons/IconTrash'
import { useS4LContext } from '@s4l/react-context'
import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'
import { IconStarfull } from '@s4l/icons/IconStarfull'
import styles from './index.module.css'

const FilterStars = () => {
  const { i18n } = useS4LContext()

  const availableStars = ['1', '2', '3', '4', '5'] as const

  return (
    <Form.Fieldset>
      <Form.Legend>{i18n.formatMessage({ id: 'global.star-rating' })}</Form.Legend>
      <Form.ClearButton icon={<IconTrash />}>
        {i18n.formatMessage({ id: 'serp.filter-clear' })}
      </Form.ClearButton>
      <div className={styles.starFilterContainer}>
        {availableStars.map(star => {
          return (
            <Form.CheckboxToggleButton
              key={`star-${star}`}
              name="stars"
              multiple
              trueValue={star}
              icon={<IconStarfull />}
            >
              {star}
            </Form.CheckboxToggleButton>
          )
        })}
      </div>
    </Form.Fieldset>
  )
}

FilterStars.displayName = 'SearchFilters.FilterStars'
export default withErrorBoundary(FilterStars)
